// Human-readable labels for RentalUser roles (common/roles.js). Kept in step with the labels
// the admin UserDetailsModal uses so a user sees the same wording for their role everywhere.
export const ROLE_LABELS = {
  customer: 'Customer',
  owner: 'Rental owner',
  admin: 'Website owner',
  // 03_requirements_missing.md - for real estate a "delivery" account is the site-visit agent.
  delivery: 'Agent',
  finance_employee: 'Finance (view)',
  finance_lead: 'Finance lead',
  finance_manager: 'Finance manager'
};

export const roleLabel = (role) => ROLE_LABELS[role] || role;
